export const EHR_OrderConfigSources = ['fhir', 'manually-in-advisor'];
export const ehrOrderAvailability_Always = 'always';
export const ehrOrderAvailability_Partial = 'partial';
export const EHR_OrderConfigAvailabilities = [ehrOrderAvailability_Always, ehrOrderAvailability_Partial];
//# sourceMappingURL=types.js.map